import React from 'react';
import CropHealthChart from './charts/CropHealthChart';
import MoistureTrendChart from './charts/MoistureTrendChart';
import CropDistributionChart from './charts/CropDistributionChart';
import WeatherRadarChart from './charts/WeatherRadarChart';
import YieldPredictionChart from './charts/YieldPredictionChart';

// Import DMV-specific chart data
import { 
  dmvCropHealthData, 
  dmvMoistureTrendData, 
  dmvCropDistributionData, 
  dmvWeatherRadarData, 
  dmvYieldPredictionData 
} from '../data/dmvChartData';

const DashboardCharts = () => {
  return (
    <div className="dashboard-charts">
      <div className="charts-grid">
        <div className="chart-card">
          <div className="chart-card-header">
            <h3>DMV Crop Health</h3>
          </div>
          <div className="chart-card-body">
            <CropHealthChart data={dmvCropHealthData} />
          </div>
        </div>
        
        <div className="chart-card">
          <div className="chart-card-header">
            <h3>DMV Soil Moisture Trends</h3>
          </div>
          <div className="chart-card-body">
            <MoistureTrendChart data={dmvMoistureTrendData} />
          </div>
        </div>
        
        <div className="chart-card">
          <div className="chart-card-header">
            <h3>DMV Crop Distribution</h3>
          </div>
          <div className="chart-card-body">
            <CropDistributionChart data={dmvCropDistributionData} />
          </div>
        </div>
        
        <div className="chart-card">
          <div className="chart-card-header">
            <h3>DMV Weather Conditions</h3>
          </div>
          <div className="chart-card-body">
            <WeatherRadarChart data={dmvWeatherRadarData} />
          </div>
        </div>
        
        <div className="chart-card">
          <div className="chart-card-header">
            <h3>DMV Yield Prediction</h3>
          </div>
          <div className="chart-card-body">
            <YieldPredictionChart data={dmvYieldPredictionData} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardCharts; 